import { PayableTypes } from '@efex-services/client/types';
import theme from '@efexteam/mui-theme';
import { Box, ThemeProvider } from '@mui/material';
import { States } from '@pages/payables/types/paymentStatus.type';
import { useState } from 'react';
import { useParams } from 'react-router-dom';
import ActionCard from './components/actionCard/ActionCard';
import ActionModal from './components/actionModal/ActionModal';
import { ActionModalType } from './components/actionModal/types';
import DetailCard from './components/detailCard/DetailCard';
import TransferHeader from './components/header/Header';
import useHandleTime from './hooks/useHandleTime';
import useTransferDetails from './hooks/useTransferDetails';
import TransferDetailsStyles from './TransferDetails.style';
import MovementAlert from './components/movementAlert/MovementAlert';

const TransferDetails = () => {
  const { uuid: transferId } = useParams<{ uuid: string }>();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalType, setIsModalType] = useState<ActionModalType>('approve');

  const handleActionModal = (type: ActionModalType) => {
    setIsModalType(type);
    setIsModalOpen(true);
  };

  const { transfer, loading, getPayments } = useTransferDetails({
    transferId: transferId || '',
  });

  const { remainingTime, timeValues } = useHandleTime({
    dueDate: transfer?.dueDate || new Date().toISOString(),
  });

  const handleCloseModal = () => {
    setIsModalOpen(false);
    getPayments();
  };

  if (!transferId) {
    return <h5>No transfer ID</h5>;
  }

  if (loading || !transfer) {
    return <h5>Loading...</h5>;
  }

  return (
    <ThemeProvider theme={theme}>
      <Box className={TransferDetailsStyles.wrapper}>
        <TransferHeader
          beneficiaryName={transfer.contact.enterprise.name || ''}
          status={transfer?.status.name as States}
        />
        <MovementAlert
          remainingTime={remainingTime}
          timeValues={timeValues}
          status={transfer.status.name as PayableTypes}
        />
        <ActionCard
          transfer={transfer}
          isLoading={loading}
          timeValues={timeValues}
          handleActionModal={handleActionModal}
        />
        <DetailCard transfer={transfer} isLoading={loading} />
      </Box>
      <ActionModal
        open={isModalOpen}
        type={isModalType}
        transfer={transfer}
        onClose={handleCloseModal}
      />
    </ThemeProvider>
  );
};

export default TransferDetails;
